// BandedNoise primitive — plan Set3 §4.5: iso-contour bands of a turbulence field.
// The textbook Perlin-marble recipe (Perlin 1985) made layer-usable: because the underlying
// fbm is 2D, the bands form CLOSED loops, swirls and branching veins with no global
// direction — unlike `waves` (a 1D wave train whose warp can only meander the stripes).
// Used by marble (veins, sharp) and snow (drift patches, soft).
//
// NOTE (repo hazard): no backticks and no GLSL-ES-300 reserved identifiers (flat/smooth/...)
// inside the template literal.
export const BANDED_NOISE_GLSL = `
// Iso-contour bands of a turbulence field (fbm mode 3 — abs-sum, blobby, 2D).
// scale = the turbulence cell size in meters (the feature scale); veining = the number of
// band cycles across the field (band spacing ~= scale / veining); sharpness > 1 narrows the
// dark band cores.  Returns [0, 1]; the mean is NOT 0.5 (a sin remap is DC-biased), so the
// layer body's colour-mean AA fade bakes/computes the true pattern mean (Set3 §4.2/§4.5).
// AA: the turbulence inside is already per-octave band-limited (fbmVal fades octaves below
// ~1px); the sin remap's sub-pixel fade lives in the layer body (band spacing vs px), which
// has the ramp context needed for the mean-converging target.
float bandedNoiseVal(vec2 p, float scale, float veining, float sharpness) {
  float t = fbmVal(p, max(scale, 1e-5), 5, 2.0, 0.5, 3);
  float band = 0.5 + 0.5 * sin(t * 6.28318530718 * veining);
  return pow(clamp(band, 0.0, 1.0), max(sharpness, 0.05));
}
`;
